import React from "react";
import { BlossomClusterCountLayer } from "./BlossomClusterCount";
import { AppleCountLayer } from "./apple-count/AppleCountLayer";
import BlossomLayer from "./BlossomLayer";
import VigourLayer from "./VigourLayer";
import { CutoffRange } from "../../../routes/customer/_customer_id/taskmap/taskmap.types";
import {
  AppleCountFeatureCollection,
  BlossomFeatureCollection,
  BlossomClusterCountFeatureCollection,
  VigourFeatureCollection,
} from "./layer.types";

export type ResultSetGeoJSON =
  | AppleCountFeatureCollection
  | BlossomFeatureCollection
  | BlossomClusterCountFeatureCollection
  | VigourFeatureCollection;

export type ResultSetLayerProps = {
  geojson: ResultSetGeoJSON;
  cutoff?: CutoffRange;
};

function isDroneBlossom(
  result: ResultSetGeoJSON,
): result is BlossomFeatureCollection {
  return "blossom_area_cm2" in result.features[0].properties;
}

function isTmsApple(
  result: ResultSetGeoJSON,
): result is AppleCountFeatureCollection {
  return "apple_count" in result.features[0].properties;
}

function isTmsBlossom(
  result: ResultSetGeoJSON,
): result is BlossomClusterCountFeatureCollection {
  return "blossom_cluster_count" in result.features[0].properties;
}

function isVigour(result: ResultSetGeoJSON): result is VigourFeatureCollection {
  return "vigour_class" in result.features[0].properties;
}

export default function ResultSetLayer({
  geojson,
  cutoff = { min: 0, max: Number.MAX_VALUE },
}: ResultSetLayerProps): React.ReactNode | null {
  if (isDroneBlossom(geojson)) {
    return <BlossomLayer geojson={geojson} cutoff={cutoff} />;
  }
  if (isTmsApple(geojson)) {
    return <AppleCountLayer geojson={geojson} cutoff={cutoff} />;
  }
  if (isTmsBlossom(geojson)) {
    return <BlossomClusterCountLayer geojson={geojson} cutoff={cutoff} />;
  }
  if (isVigour(geojson)) {
    return <VigourLayer geojson={geojson} cutoff={cutoff} />;
  }

  return null;
}
